export default __webpack_public_path__ + "static/media/how-to-daily-schema.141ebbc1.svg";